import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SetupAssistant from "./routes/SetupAssistant";
import AccountRoles from "./routes/AccountRoles";
import ProgrammeRoles from "./routes/ProgrammeRoles";
import LearningCourseRoles from "./routes/LearningCourseRoles";
import ClassRoles from "./routes/ClassRoles";

export default store => ({
  path: "roles-and-permissions",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "roles-and-permissions" */ "./components"),
      import(
        /* webpackChunkName: "roles-and-permissions" */ "./modules/RolesAndPermissionsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: importedModule1.NAME,
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [
    SetupAssistant(store),
    AccountRoles(store),
    ProgrammeRoles(store),
    LearningCourseRoles(store),
    ClassRoles(store),
  ],
});
